/** @value `newsletter-popup-turned-off` */
export const POPUP__COOKIE: string = "newsletter-popup-turned-off";
/** @value `preferences-enabled` */
export const PREFERENCES__COOKIE: string = "preferences-enabled";
